import React from 'react'
import { Card, Ratio } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export type VideoCardProps = {
  url: string
  subtitle: string
  redirectUrl: string
}

export const VideoCard = ({ url, subtitle, redirectUrl }: VideoCardProps) => {
  return (
    <Card>
      <Ratio aspectRatio="16x9">
        <iframe
          src={url}
          title="Our products in action"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Ratio>
      <Card.Body>
        <Link to={redirectUrl}>{subtitle}</Link>
      </Card.Body>
    </Card>
  )
}
